function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/* 文档地址: https://wiki.didapinche.com/index.php?title=APP_JS%E6%8E%A5%E5%8F%A3%E8%AF%B4%E6%98%8E#APP.E6.8E.A5.E5.8F.A3 */
import { Deferred } from './util.async';
import Env from './util.env';

var Didasdk = /*#__PURE__*/function () {
  function Didasdk() {
    _classCallCheck(this, Didasdk);

    this.jsBridge = null;
    this.__isInited = false; // 是否完成初始化

    this.__initDeferred = new Deferred();
    this.__window = window.top;

    try {
      this.__document = window.top.document;

      if (Env.inApplication) {
        this.__init();
      }
    } catch (e) {}
  }

  _createClass(Didasdk, [{
    key: "__init",
    value: function __init() {
      var _this = this;

      if (this.__window.WebViewJavascriptBridge) {
        this.__resolveInit();
      } else {
        this.__document.addEventListener('WebViewJavascriptBridgeReady', this.__resolveInit.bind(this), false);

        if (!this.__window.WVJBCallbacks) {
          this.__window.WVJBCallbacks = [this.__resolveInit.bind(this)];
        } else if (this.__window.WVJBCallbacks && this.__window.WVJBCallbacks.push) {
          this.__window.WVJBCallbacks = this.__window.WVJBCallbacks.push(this.__resolveInit.bind(this));
        }

        var WVJBIframe = this.__document.createElement('iframe');

        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'https://__bridge_loaded__';

        this.__document.documentElement.appendChild(WVJBIframe);

        setTimeout(function () {
          _this.__document.documentElement.removeChild(WVJBIframe);
        }, 0);
      }
    }
  }, {
    key: "__resolveInit",
    value: function __resolveInit() {
      if (!this.__isInited && this.__window.WebViewJavascriptBridge) {
        this.__isInited = true;
        this.jsBridge = this.__window.WebViewJavascriptBridge;
        console.log(this.jsBridge);
        console.log(this.__initDeferred);

        this.__initDeferred.resolve(this.jsBridge);
      }
    }
  }, {
    key: "ready",
    value: function ready(fn) {
      if (typeof fn !== 'function') return;

      this.__initDeferred.promise.then(fn);
    }
  }, {
    key: "registerHandler",
    value: function registerHandler(methodName, callBack) {
      this.jsBridge.registerHandler(methodName, callBack);
    }
  }, {
    key: "callHandler",
    value: function callHandler(methodName, data) {
      var _this2 = this;

      return new Promise(function (resolve) {
        _this2.jsBridge.callHandler(methodName, data, function (responseData) {
          return resolve(responseData);
        });
      });
    }
    /* JS 调用 APP */

    /* 获取当前位置 */

  }, {
    key: "getLocation",
    value: function getLocation() {
      return this.callHandler('getLocation', null);
    }
    /* 获取设备信息 */

  }, {
    key: "getDeviceId",
    value: function getDeviceId() {
      return this.callHandler('getDeviceId', null);
    }
    /* 获取网络状态 */

  }, {
    key: "getNetworkStatus",
    value: function getNetworkStatus() {
      return this.callHandler('getNetworkStatus', null);
    }
    /* 跳转设置界面 */

  }, {
    key: "startNetworkSetting",
    value: function startNetworkSetting() {
      return this.callHandler('startNetworkSetting', null);
    }
    /* 跳转编辑短信界面 */

  }, {
    key: "sendMsg",
    value: function sendMsg(_ref) {
      var num = _ref.num,
          msg = _ref.msg;
      var data = {
        num: num,
        msg: msg
      };
      return this.callHandler('sendMsg', data);
    }
    /* 点击App 导航栏分享按钮 唤起分享控件 */

  }, {
    key: "shareByAppBtn",
    value: function shareByAppBtn() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          thumbnail = _ref2.thumbnail,
          title = _ref2.title,
          des = _ref2.des,
          link = _ref2.link,
          id = _ref2.id;

      var sharedata = {
        thumbnail: thumbnail,
        // 缩略图地址
        title: title,
        // 标题
        des: des,
        // 文案描述
        link: link,
        // 分享链接
        id: id // 标识

      };
      return this.callHandler('statusBarShare', sharedata);
    }
    /* 页面内直接跳转分享 传具体channel */

  }, {
    key: "shareByH5Channel",
    value: function shareByH5Channel() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          thumbnail = _ref3.thumbnail,
          title = _ref3.title,
          des = _ref3.des,
          link = _ref3.link,
          id = _ref3.id,
          channel = _ref3.channel;

      var sharedata = {
        thumbnail: thumbnail,
        // 缩略图地址
        title: title,
        // 标题
        des: des,
        // 文案描述
        link: link,
        // 分享链接
        id: id,
        // 标识
        channel: channel // string, 渠道  wxmsg/wxtimeline/dingtalk/message

      };
      return this.callHandler('shareOnTheWebviewPage', sharedata);
    }
    /* 点击页面内的元素 唤起分享控件 */

  }, {
    key: "shareByH5Btn",
    value: function shareByH5Btn() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          thumbnail = _ref4.thumbnail,
          title = _ref4.title,
          des = _ref4.des,
          link = _ref4.link,
          id = _ref4.id;

      var sharedata = {
        thumbnail: thumbnail,
        title: title,
        des: des,
        link: link,
        id: id
      };
      return this.callHandler('clickControlToShare', sharedata);
    }
    /* APP 调用 JS */

  }, {
    key: "listenRefreshLocation",
    value: function listenRefreshLocation(cb) {
      this.registerHandler('refreshLocation', cb);
    }
  }, {
    key: "listenShareCallBack",
    value: function listenShareCallBack(cb) {
      this.registerHandler('shareCallBack', cb);
    }
  }, {
    key: "listenInvokePayCallBack",
    value: function listenInvokePayCallBack(cb) {
      this.registerHandler('invokePayCallBack', cb);
    }
  }]);

  return Didasdk;
}();

export default new Didasdk();